import { useInvalidateOrganization } from "@/hooks/use-invalidate-organization";
import { OrganizationSettingsCards } from "@papier/auth-ui";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_app/organization/settings")({
  component: RouteComponent,
});

function RouteComponent() {
  const invalidateOrganization = useInvalidateOrganization();

  return <OrganizationSettingsCards onSuccess={invalidateOrganization} />;
}
